import { render, staticRenderFns } from "./clear-history.vue?vue&type=template&id=95c8e8a4&"
import script from "./clear-history.vue?vue&type=script&lang=js&"
export * from "./clear-history.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports